import { Component, EventEmitter, Input, NgZone, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirectHelper } from '@app/app/page-modules/resource/store/editor/content/helpers/redirect.helper';
import { NestedPathHelper } from '@app/app/shared/helpers/nested-path.helper';
import { CardsLayoutType, PlaylistCardShort } from '@app/app/shared/models';

@Component({
  selector: 'ptl-collection-cards-view',
  templateUrl: './collection-cards-view.component.html',
  styleUrls: ['./collection-cards-view.component.scss'],
})
export class CollectionCardsViewComponent implements OnDestroy {
  @Input() cards: PlaylistCardShort[] = [];
  @Input() currentLayoutView: CardsLayoutType = 'CardView';
  private subscriptionEnd$ = new EventEmitter();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ngZone: NgZone,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnDestroy() {
    this.subscriptionEnd$.emit();
  }

  onCardClick(card: PlaylistCardShort): void {
    if (card.lmsCourseUrl) {
      window.open(card.lmsCourseUrl, '_blank', 'noopener,noreferrer');
      return;
    }

    if (!card.uri) {
      return;
    }

    const currentUrl = this.router.url.split('?')[0];
    const parsedPath = NestedPathHelper.parsePath(currentUrl);

    const isProgramContext = parsedPath?.currentEntity?.type === 'program' || currentUrl.includes('/programs/');
    const isCourseContext = parsedPath?.currentEntity?.type === 'course' || currentUrl.includes('/courses/');
    if (isProgramContext || isCourseContext) {
      const entityType = card.type === 'CARD' ? 'card' : card.v3CardType === 'PROGRAM' ? 'program' : 'course';
      const newPath = NestedPathHelper.addEntityToPath(currentUrl, entityType, card.uri, 'content');
      RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, newPath);
      return;
    }

    if (card.type === 'CARD') {
      const newCardPath = NestedPathHelper.addEntityToPath(currentUrl, 'card', card.uri, 'content');
      RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, newCardPath);
      return;
    }

    if (!parsedPath) {
      RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, `/courses/${card.uri}/content`);
      return;
    }

    let entityType: 'program' | 'course' = 'course';
    if (parsedPath.currentEntity?.type === 'course') {
      entityType = 'course';
    } else if (parsedPath.currentEntity?.type === 'program') {
      entityType = card.collectionType === 'PROGRAM' ? 'program' : 'course';
    } else if (card.collectionType === 'COURSE') {
      entityType = 'course';
    }

    const newPath = NestedPathHelper.addEntityToPath(currentUrl, entityType, card.uri, 'content');
    RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, newPath);
  }
}
